import { h } from 'preact';

type PropTypes = {
  id: string;
  elapsedTime: number;
  duration: number;
  adjustedFormulae?: boolean;
  style?: h.JSX.CSSProperties;
  barStyle?: h.JSX.CSSProperties;
  onClick: (e: MouseEvent) => void;
};

export default function ProgressBar({
  id = 'progress',
  style = {},
  barStyle = {},
  elapsedTime = 0,
  duration,
  adjustedFormulae = false,
  onClick = () => {}
}: PropTypes) {
  const progress = adjustedFormulae
    ? Math.sin((elapsedTime / duration) * (Math.PI / 2)) * 100
    : (elapsedTime * 100) / duration;
  const styles = {
    root: {
      height: '3px',
      width: '100%',
      background: 'rgba(255, 255, 255, 0.1)',
      ...style
    },
    bar: {
      height: '100%',
      background: 'red',
      transition: '1000ms width linear',
      width: `${progress}%`,
      ...barStyle
    }
  };

  return (
    <div style={styles.root} id={id} onClick={onClick} data-zone="progress_bar">
      <div style={styles.bar} />
    </div>
  );
}
